<template>
  <section style="overflow-x: hidden; padding-bottom: 100px">
    <!-- Intro Section -->
    <div class="container">
      <div class="row">
        <div class="col-10 offset-1 text-center col-lg-8 offset-lg-2">
          <h1
            class="page-title text-gradient"
            data-aos="fade-right"
            data-aos-easing="ease-in-out-quad"
            data-aos-once="true"
            data-aos-duration="1000"
          >
            Become a Volunteer
          </h1>
        </div>
      </div>
    </div>

    <!-- Volunteer Content -->
    <div class="container">
      <div class="row">
        <div
          class="col-10 offset-1 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2 text-left"
        >
          <h6
            class="about-sub-heading my-5"
            data-aos="fade-up"
            data-aos-once="true"
          >
            Volunteer with Us – Be Part of the Carnival Magic!
          </h6>

          <div class="about-text" data-aos="fade-up">
            <p>
              Join our incredible team and help bring the Leicester Caribbean
              Carnival to life! As we celebrate 41 years of culture, community,
              and carnival spirit, we’re looking for passionate, dedicated, and
              energetic volunteers to be part of this unforgettable event.
            </p>
            <h6>Why Volunteer?</h6>
            <ul>
              <li>Make a real difference in your community</li>
              <li>Meet new people and be part of a vibrant team</li>
              <li>
                Gain experience in event coordination, hospitality, and cultural
                programming
              </li>
              <li>
                Celebrate and support African-Caribbean culture in Leicester
              </li>
            </ul>

            <h6>Volunteer Roles Available:</h6>
            <ul>
              <li>
                <strong>Event Marshals:</strong> Help guide attendee ticketing
                and keep the event running smoothly
              </li>
              <li>
                <strong>Hospitality Team:</strong> Assist with artist and guest
                services
              </li>
              <li>
                <strong>Procession Coordinators:</strong> Work directly with
                performers and floats
              </li>
              <li>
                <strong>Eco Team:</strong> Promote sustainability and help keep
                Victoria Park green and clean
              </li>
            </ul>

            <h6>What You’ll Get:</h6>
            <ul>
              <li>A 41<sup>st</sup> themed volunteer t-shirt</li>
              <li>Free training and orientation session</li>
              <li>A certificate of participation</li>
              <li>Refreshments on the day</li>
              <li>An unforgettable experience!</li>
            </ul>

            <h6>Sign up to be a volunteer</h6>
            <p><strong>📞: </strong>0116 2211793</p>
            <p><em>* All volunteers must be 18 years or older.</em></p>

            <a
              href="https://forms.gle/FL7fZWe6aGKXn7fr5"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b-button
                class="btn-carnival bg-yellow text-blue font-weight-bold mt-3"
              >
                Become a Volunteer
              </b-button>
            </a>

            <!-- Troupes Section -->
            <hr class="my-5" />
            <h6 class="about-sub-heading mt-5" data-aos="fade-up">
              Troupes - Join Procession
            </h6>
            <p>
              <strong
                >Be the Heart of the Carnival - Register Your Troupe
                Today!</strong
              >
            </p>
            <p>
              Whether you're a seasoned carnival band or a first-time troupe
              bursting with creativity, we want you to be part of the vibrant
              spectacle that is the Leicester Caribbean Carnival 2026!
            </p>
            <p>
              Bring your music, costumes, dance, and cultural pride to the
              streets of Leicester and celebrate this year's theme:<br /><strong
                >"Crowned In Culture."</strong
              >
            </p>

            <h6>Why Join as a Troupe?</h6>
            <ul>
              <li>Showcase your cultural expression and creativity</li>
              <li>
                Be featured in one of the UK's biggest community-led carnivals
              </li>
              <li>Inspire and energise the community</li>
              <li>Celebrate the legacy of Caribbean and African heritage</li>
            </ul>

            <p><strong>Register Your Troupe Here:</strong></p>
            <a
              href="https://forms.gle/M6KaZdiCtS53cb2DA"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b-button
                class="btn-carnival bg-yellow text-blue font-weight-bold mt-3"
              >
                Sign Up a Troupe
              </b-button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.about-sub-heading {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.69;
  letter-spacing: -0.2px;
  color: #565887;
}

.about-text {
  font-size: 15px;
  line-height: 1.8;
  color: #565887;
  margin-bottom: 1.5rem;
  text-align: left;
}

.btn-carnival {
  padding: 0.5rem 1.5rem;
  font-size: 16px;
  border-radius: 6px;
}
</style>
